module.exports = __webpack_public_path__ + "img/3.5903b279.png";